export const getObjectKeysByValue = (obj: any, value: boolean) => {
    return Object.keys(obj).filter(key => obj[key] === value);
  };